'use client';

import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

interface ConfirmNavigationModalProps {
  isOpen: boolean;
  /** Defaults to comic-book-generation copy; pass a different message for other guarded flows. */
  message?: string;
  onStay: () => void;
  onLeave: () => void;
}

/**
 * Shown when the user tries to navigate away (logo, sidebar links) while a guarded process — by
 * default, comic generation — is in progress. Unlike a native `beforeunload` dialog (which only
 * covers closing/refreshing the tab), this covers in-app navigation, which Next.js `<Link>`
 * clicks would otherwise just silently perform.
 */
export default function ConfirmNavigationModal({ isOpen, message, onStay, onLeave }: ConfirmNavigationModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[80] p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-10 text-center">
        <h3 className="text-[28px] font-bold text-[#333] pb-8 leading-[1.5] text-pretty">
          Leave while we're creating your book?
        </h3>

        <div className="flex flex-col gap-2.5">
          <PrimaryButton id="btn-confirm-nav-stay" onClick={onStay} className="w-full">
            Stay and keep creating
          </PrimaryButton>
          <SecondaryButton id="btn-confirm-nav-leave" onClick={onLeave} className="w-full">
            Leave anyway
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
}
